import { Vehicle } from '@otw/models/inventory/inventory';

export interface TempTagRequestEmailInput {
  companyName: string;
  vehicles: Vehicle[];
  senderName: string;
}

export interface TempTagRequestEmail {
  to: string;
  subject: string;
  body: string;
}

const getVinLast4 = (vin: string | undefined | null): string | null => {
  const trimmed = vin?.trim();
  if (!trimmed || trimmed.length < 4) return null;
  return trimmed.slice(-4);
};

export const buildTempTagRequestSubject = (
  companyName: string,
  vehicles: Vehicle[],
): string => {
  const company = companyName.trim() || 'Customer';
  const vinSuffixes = vehicles
    .map((vehicle) => getVinLast4(vehicle.vin))
    .filter((suffix): suffix is string => !!suffix);

  const vinPart = vinSuffixes.length > 0 ? ` ${vinSuffixes.join(', ')}` : '';
  return `Temp Tag Request for ${company}${vinPart}`;
};

export const buildTempTagRequestBody = (
  vehicles: Vehicle[],
  senderName: string,
): string => {
  const vinLines = vehicles.map((vehicle) => {
    const vin = vehicle.vin?.trim();
    return vin || 'VIN not available';
  });

  const signature = senderName.trim() || 'Optic Truck Works';

  return [
    'Hello,',
    '',
    'Please send temp tags for the following VIN:',
    '',
    ...vinLines,
    '',
    'Thank you!',
    signature,
  ].join('\n');
};

export const generateTempTagRequestEmail = (
  input: TempTagRequestEmailInput,
  to: string,
): TempTagRequestEmail => ({
  to,
  subject: buildTempTagRequestSubject(input.companyName, input.vehicles),
  body: buildTempTagRequestBody(input.vehicles, input.senderName),
});
